'use strict';

angular.module('app.influencerDetail', [])

    .controller('InfluencerDetailsCtrl', function ($scope, $rootScope, $http, $modal, $modalInstance, $window, adminService, advertiserProjectDetailService) {

        var definitions = angular.copy($rootScope.definitions);
        $scope.countries = definitions.countries;
        $scope.languages = angular.copy(definitions.languages);
        $scope.goToURL = function (selectedChannel, $event) {
            var platformDomain = null;
            var channelDomain = null;
            var getInfluencerDetailsDomainUrl = $rootScope.apiUrl + 'admin/getPlarformDomainUrl/' + selectedChannel.id;
            $http.get(getInfluencerDetailsDomainUrl, {
                    loader: false
                })
                .success(function (responseInfluencerDetailsDomainUrl) {
                    platformDomain = responseInfluencerDetailsDomainUrl.data.domain;
                    channelDomain = responseInfluencerDetailsDomainUrl.channel.handle;
                    if (responseInfluencerDetailsDomainUrl.channel.isLinked == 1) {
                        if (responseInfluencerDetailsDomainUrl.channel.platform_id == 6) {
                            $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + responseInfluencerDetailsDomainUrl.channel.youtubeType.toLowerCase() + '/' + selectedChannel.handle, '_blank');
                        } else {
                            $window.open(platformDomain == null ? 'http://' + channelDomain : 'https://' + platformDomain + selectedChannel.handle, '_blank');
                        }
                    }
                });
            $event.stopPropagation();
        };

        $scope.searchCountries = function (event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for (var i = 0; i < $scope.countries.length; i++) {
                    if ($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                        var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[i];
                        checkbox.animate({
                            scrollTop: item.parentElement.parentElement.offsetTop
                        }, {
                            duration: 'medium',
                            easing: 'swing'
                        });
                        break;
                    }
                }
            }
        }

        $scope.lastSearchLanguageIndex = undefined;

        $scope.searchLanguages = function (event) {
            if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                for (var i = 0; i < $scope.languages.length; i++) {
                    if ($scope.lastSearchLanguageIndex !== i && $scope.languages[i].name && $scope.languages[i].name.toLowerCase().indexOf(event.key.toLowerCase()) === 0) {
                        $scope.lastSearchLanguageIndex = i;
                        var checkbox = $("#selectLanguageDD > .checkboxLayer.show .checkBoxContainer")
                        var item = checkbox.find('label')[(i-1)]; // -1 cause group in dropdown has remove item group:flase, so when compare with $scope.languages we need exactly index
                        checkbox.animate({
                            scrollTop: item.parentElement.parentElement.offsetTop
                        }, {
                            duration: 'medium',
                            easing: 'swing'
                        });
                        break;
                    }
                }
            }
        }

        $scope.pendingCompleted = null;
        if ($scope.flag == false) {
            $scope.pendingCompleted = false;
        }
        $scope.pendingCompletedClick = function () {
            $scope.pendingCompleted == !$scope.pendingCompleted;
        }

        $scope.channels = [];
        $scope.addNewChannels = [];
        $scope.editChannels = [];
        $scope.tempEditChannels = [];
        $scope.removeChannels = [];
        $scope.hasChannel = null;
        $scope.isValidToAdd = true;
        $scope.enableWatch = false;
        $scope.numberClick = 0;

        $scope.networks = [];
        var object = {
            id: null,
            name: "No Network",
            description: null,
            contact_email: null,
            country: {
                id: null,
                code: null,
                name: null,
                isActive: null
            },
            net_id: null,
            address: null,
            phone: null,
            ticked: false
        }
        $scope.networks.push(object);

        $scope.outputLanguage = [];
        $scope.approval = [];
        $scope.status = [];
        $scope.gender = [];

        var getCurrentInfluencerUrl = $rootScope.apiUrl + 'admin/getCurrentInfluencer?blog_id=' + $scope.id;
        $http.get(getCurrentInfluencerUrl, {
                loader: false
            })
            .success(function (responseCurrentInfluencer) {
                $scope.InfluencerDetail = responseCurrentInfluencer.data;
                $scope.influencerId = responseCurrentInfluencer.data.id;
                $scope.domain = responseCurrentInfluencer.data.domain;
                $scope.name = responseCurrentInfluencer.data.name;
                $scope.phone = responseCurrentInfluencer.data.phone;
                $scope.email = responseCurrentInfluencer.data.email;
                $scope.description = responseCurrentInfluencer.data.description;
                $scope.pendingCompleted = responseCurrentInfluencer.data.pending_completed == 1 ? true : false;
                if (responseCurrentInfluencer.data.systemEmail != null) {
                    $scope.system_email = responseCurrentInfluencer.data.systemEmail;
                } else {
                    $scope.system_email = responseCurrentInfluencer.data.id + "@getachoo.com";
                }

                var platformTypeUrl = $rootScope.apiUrl + 'admin/getPlatformListForBlog/' + $scope.InfluencerDetail.id;
                $http.get(platformTypeUrl, {
                        loader: false
                    })
                    .success(function (responsePlatformType) {
                        var tempPlatformList = responsePlatformType.platformList;
                        $scope.InfluencerDetail.platformList = [];
                        $scope.InfluencerDetail.platformList = responsePlatformType.platformList;

                        $scope.countries.forEach(function (valCountry) {
                            if ($scope.InfluencerDetail.country != null) {
                                if (valCountry.id == $scope.InfluencerDetail.country.id) {
                                    valCountry.ticked = true;
                                    $scope.outputCountry = valCountry;
                                }
                            }
                        })

                        $scope.languages.forEach(function (valLanguage) {
                            $scope.InfluencerDetail.influencerLanguages.forEach(function (item) {
                                if (item.language != null) {
                                    if (valLanguage.id == item.language.id) {
                                        valLanguage.ticked = true;
                                        $scope.outputLanguage.push(valLanguage);
                                    }
                                }
                            })
                        })

                        buildGroupingLanguageDropdown($scope.InfluencerDetail.defaultLanguage, $scope.InfluencerDetail.country.id);

                        var getInfluencerDetailsActiveUrl = $rootScope.apiUrl + 'admin/getInfluencerActive';
                        $http.get(getInfluencerDetailsActiveUrl, {
                                loader: false
                            })
                            .success(function (responseInfluencerDetailsActive) {
                                angular.forEach(responseInfluencerDetailsActive.data, function (valStatus) {
                                    $scope.status.push(valStatus);
                                    if (valStatus.id == $scope.InfluencerDetail.isActive) {
                                        valStatus.ticked = true;
                                        $scope.outputStatus = valStatus;
                                    }
                                })

                                var getInfluencerDetailsStatusUrl = $rootScope.apiUrl + 'admin/getInfluencerStatus';
                                $http.get(getInfluencerDetailsStatusUrl, {
                                        loader: false
                                    })
                                    .success(function (responseInfluencerDetailsStatus) {
                                        angular.forEach(responseInfluencerDetailsStatus.data, function (valApproved) {
                                            $scope.approval.push(valApproved);
                                            if (valApproved.id == $scope.InfluencerDetail.status) {
                                                valApproved.ticked = true;
                                                $scope.outputApproval = valApproved;
                                            }
                                        })

                                        var influencerDetailsNetwordsUrl = $rootScope.apiUrl + 'networks';
                                        $http.get(influencerDetailsNetwordsUrl, {
                                                loader: false
                                            })
                                            .success(function (responseInfluencerDetailsNetwords) {
                                                angular.forEach(responseInfluencerDetailsNetwords.data, function (valNetwork) {
                                                    if (valNetwork.deletedFlag == 0) {
                                                        $scope.networks.push(valNetwork);
                                                        if ($scope.InfluencerDetail.network != null) {
                                                            if (valNetwork.id == $scope.InfluencerDetail.network.id) {
                                                                valNetwork.ticked = true;
                                                                // $scope.outputNetwork = val;
                                                            }
                                                        }
                                                    }
                                                })

                                                var newInfluencerDetailsInfluencerGenderUrl = $rootScope.apiUrl + 'admin/getInfluencerGender';
                                                $http.get(newInfluencerDetailsInfluencerGenderUrl, {
                                                        loader: false
                                                    })
                                                    .success(function (responseInfluencerDetailsGender) {
                                                        angular.forEach(responseInfluencerDetailsGender.data, function (valGender) {
                                                            $scope.gender.push(valGender);
                                                            if (valGender.id == $scope.InfluencerDetail.gender) {
                                                                $scope.selectedGender = valGender.id;
                                                                valGender.checked = true;
                                                            }
                                                        })

                                                        var newInfluencerDetailsInfluencerDismissReasonUrl = $rootScope.apiUrl + 'admin/getDismissReason';
                                                        $http.get(newInfluencerDetailsInfluencerDismissReasonUrl, {
                                                                loader: false
                                                            })
                                                            .success(function (responseInfluencerDetailsDismissReason) {
                                                                $scope.dismissReasons = responseInfluencerDetailsDismissReason.data;
                                                                angular.forEach($scope.dismissReasons, function (reason) {
                                                                    reason.ticked = false;
                                                                    if (reason.id == $scope.InfluencerDetail.dismiss_reason) {
                                                                        reason.ticked = true;
                                                                    }
                                                                })
                                                            })
                                                    })
                                            })
                                    })
                            })
                    })
                    .error(function (responsePlatformType) {

                    })

                $scope.status_icon = adminService.getActiveIcon($scope.InfluencerDetail.isActive);
                $scope.approval_icon = adminService.getApproveIcon($scope.InfluencerDetail.status);

                var influencerDetailsChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.id;
                $http.get(influencerDetailsChannelUrl, {
                        loader: false
                    })
                    .success(function (responseInfluencerDetailsChannel) {
                        angular.forEach(responseInfluencerDetailsChannel.data, function (item) {
                            $scope.channels.push(item);
                        })
                        $scope.hasChannel = $scope.channels.length;
                    })

                $scope.PlatformIcon = function (platform_id) {
                    return adminService.getPlatformIcon(platform_id);
                }
                $scope.enableWatch = true;
            })


        $scope.removeChannelFromDB = function (influencer_management_log_id) {
            angular.forEach($scope.removeChannels, function (item) {
                var data = {
                    id: item.id,
                    influencer_management_log_id: influencer_management_log_id
                }

                var req = {
                    url: $rootScope.apiUrl + 'channel/deleteChannel',
                    method: 'POST',
                    data: data
                }

                $http(req).success(function (responseChannelRemoval) {

                    })
                    .error(function (responseChannelRemoval) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseChannelRemoval.message;
                    })
            })
        }

        $scope.editChannelInDB = function (influencer_management_log_id) {
            angular.forEach($scope.editChannels, function (item) {
                var editChannelData = {
                    id: item.id,
                    handle: item.handle,
                    type: item.type,
                    platform_id: item.platform_id,
                    youtubeType: item.youtubeType,
                    influencer_management_log_id: influencer_management_log_id
                }

                var req = {
                    url: $rootScope.apiUrl + 'channel/updateChannel',
                    method: 'POST',
                    data: JSON.stringify(editChannelData)
                }

                $http(req).success(function (responseEditChannel) {

                    })
                    .error(function (responseEditChannel) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseEditChannel.message;
                    })
            })
        }

        $scope.addNewChannelToDB = function (id, influencer_management_log_id) {

            angular.forEach($scope.addNewChannels, function (item) {
                var newChanneldata = {
                    id: null,
                    handle: item.handle,
                    type: item.type,
                    platform_id: item.platform_id,
                    blog_id: id,
                    youtubeType: item.youtubeType,
                    influencer_management_log_id: influencer_management_log_id
                }

                var req = {
                    url: $rootScope.apiUrl + 'channel/addChannel',
                    method: 'POST',
                    data: JSON.stringify(newChanneldata)
                }

                $http(req).success(function (responseAddNewChannel) {

                    })
                    .error(function (responseAddNewChannel) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = responseAddNewChannel.message;
                    })
            })
        }

        $scope.handleChannels = function (id, influencer_management_log_id) {
            if ($scope.removeChannels != null && $scope.removeChannels.length > 0) {
                $scope.removeChannelFromDB(influencer_management_log_id);
            }
            if ($scope.editChannels != null && $scope.editChannels.length > 0) {
                $scope.editChannelInDB(influencer_management_log_id);
            }
            if ($scope.addNewChannels != null && $scope.addNewChannels.length > 0) {
                $scope.addNewChannelToDB(id, influencer_management_log_id);
            }
        }

        $scope.checkDuplicateChannel = function (channel, channelList) {
            angular.forEach(channelList, function (item) {
                if (channel.handle == item.handle && channel.platform_id == item.platform_id) {
                    $scope.isValidToAdd = false;
                }
            });
        }

        $scope.selectDismissReason = function () {
            $scope.selectedStatus = "";
            $scope.status.forEach(function (val) {
                if (val.id == 2) {
                    val.ticked = true;
                } else {
                    val.ticked = false;
                }

            });
        }

        $scope.selectGender = function (gender) {
            angular.forEach($scope.gender, function (item) {
                if (item.id == gender.id) {
                    item.checked = true;
                    $scope.selectedGender = gender.id;
                } else {
                    item.checked = false;
                }
            })
        }

        $scope.selectCountry = function (country) {
            if (country.isActive == 0) {
                angular.forEach($scope.dismissReasons, function (reason) {
                    reason.ticked = false;
                });
                $scope.dismissReasons[5].ticked = true;
                $scope.selectDismissReason();
            } else {
                angular.forEach($scope.dismissReasons, function (reason) {
                    reason.ticked = false;
                });

                $scope.selectedStatus = "";
                $scope.status.forEach(function (val) {
                    if (val.id == $scope.outputStatus.id) {
                        val.ticked = true;
                    } else {
                        val.ticked = false;
                    }
                });
            }

            changeLanguage(country.id);
        }

        $scope.save = function (id, isPending) {

            $scope.selectedCountryId = "";
            $scope.countries.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedCountryId = val.id;
                }
            });

            $scope.selectedNetworkId = "";
            $scope.networks.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedNetworkId = val.id;
                }
            });

            $scope.selectedLanguageId = [];
            $scope.languages.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedLanguageId.push(val.id)
            });

            $scope.selectedStatus = "";
            $scope.status.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedStatus = val.id;
            });

            $scope.selectedApproval = "";
            $scope.approval.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedApproval = val.id;
            });

            $scope.selectedReason = "";
            $scope.dismissReasons.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedReason = val.id;
            });

            var influencerDetailsdata = {
                domain: $scope.domain,
                name: $scope.name,
                description: $scope.description,
                isActive: $scope.selectedStatus,
                network: $scope.selectedNetworkId,
                country: $scope.selectedCountryId,
                phone: $scope.phone,
                email: $scope.email,
                status: 2,
                // status: $scope.selectedApproval,
                languages: $scope.selectedLanguageId,
                system_email: $scope.system_email,
                pending_completed: $scope.pendingCompleted,
                gender: $scope.selectedGender,
                dismiss_reason: $scope.selectedReason,
                isPending: isPending == true ? true : false
            }

            adminService.updateInfluencer(id, influencerDetailsdata, true)
                .then(function (responseInfDetail) {
                    //handle channels: remove-edit-add
                    $scope.handleChannels(id, responseInfDetail.influencer_management_log_id);
                    if($scope.influencerDetailsFromInfluencerLogModalInstance == undefined &&
                        $scope.influencerManagementLogDetailedModalInstance == undefined) {
                        $scope.closeModal();
                    } else if($scope.influencerDetailsFromInfluencerLogModalInstance != undefined) {
                        $scope.influencerDetailsFromInfluencerLogModalInstance.close();
                    } else if($scope.influencerManagementLogDetailedModalInstance != undefined) {
                        $scope.influencerDetailsModalInstance.close();
                        $scope.influencerManagementLogDetailedModalInstance.close();
                    }

                }, function (responseInfDetail) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseInfDetail.message;
                })
        }

        $scope.saveNPrevious = function (id) {

            //from current index, get previous index
            $scope.influencerIndex = $scope.influencerIndex - 1;
            var previousInfluencerIndex = 0;
            if ($scope.influencerIndex >= 0 && $scope.currentPage >= 1) {
                previousInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.influencerIndex;
            } else if ($scope.influencerIndex < 0 && $scope.currentPage > 1) {
                $scope.currentPage -= 1;
                $scope.influencerIndex = 24;
                previousInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.influencerIndex;
            } else if ($scope.influencerIndex < 0 && $scope.currentPage == 1) {
                $scope.influencerIndex = 0;
                previousInfluencerIndex = -1;
            }

            $scope.selectedDetailsCountryId = "";
            $scope.countries.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedDetailsCountryId = val.id;
                }
            });

            $scope.selectedDetailsNetworkId = "";
            $scope.networks.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedDetailsNetworkId = val.id;
                }
            });

            $scope.selectedDetailsLanguageId = [];
            $scope.languages.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsLanguageId.push(val.id)
            });

            $scope.selectedDetailsStatus = "";
            $scope.status.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsStatus = val.id;
            });

            $scope.selectedDetailsApproval = "";
            $scope.approval.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsApproval = val.id;
            });

            $scope.selectedGender = "";
            $scope.gender.forEach(function (val) {
                if (val.checked === true)
                    $scope.selectedGender = val.id;
            });

            var influencerDetaildata = {
                domain: $scope.domain,
                name: $scope.name,
                description: $scope.description,
                isActive: $scope.selectedDetailsStatus,
                network: $scope.selectedDetailsNetworkId,
                country: $scope.selectedDetailsCountryId,
                phone: $scope.phone,
                email: $scope.email,
                status: 2,
                // status: $scope.selectedDetailsApproval,
                languages: $scope.selectedDetailsLanguageId,
                system_email: $scope.system_email,
                pending_completed: $scope.pendingCompleted,
                dismiss_reason: $scope.selectedReason,
                gender: $scope.selectedGender
            }

            var req = {
                url: $rootScope.apiUrl + 'admin/updateNPrevious/' + id,
                method: 'POST',
                data: JSON.stringify(influencerDetaildata)
            }

            adminService.updateNPrevious(id, influencerDetaildata, true)
                .then(function (responseUpdateNPreviousInf) {
                    //handle channels: remove-edit-add
                    $scope.handleChannels(id, responseUpdateNPreviousInf.influencer_management_log_id);
                    var previousData = {
                        searchString: $scope.searchString,
                        selectedPlatform: $scope.selectedPlatform,
                        selectedCountryId: $scope.selectedCountryId,
                        selectedNetworkId: $scope.selectedNetworkId,
                        selectedLanguageId: $scope.selectedLanguageId,
                        selectedStatus: $scope.selectedStatus,
                        selectedApproval: $scope.selectedApproval,
                        pageNo: $scope.currentPage,
                        sortByColumn: $scope.fieldName,
                        sortType: $scope.order,
                        selectedGender: $scope.selectedGender
                    };

                    var req = {
                        url: $rootScope.apiUrl + 'admin/getPreviousInfluencer/' + previousInfluencerIndex,
                        method: 'POST',
                        data: JSON.stringify(previousData)
                    }
                    $http(req).success(function (responsePreviousInfluencer) {
                            if (responsePreviousInfluencer.data.id == null) {
                                // var errorModalInstance = $modal.open({
                                //     scope: $scope,
                                //     templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                //     windowClass: 'modal-dialog-mention-error'
                                // });
                                // $scope.errorModalInstance = errorModalInstance;
                                // $scope.errorMessage = responsePreviousInfluencer.data;
                                $scope.influencerDetailsModalInstance.close();
                            } else {
                                $scope.InfluencerDetail = responsePreviousInfluencer.data;
                                $scope.influencerId = responsePreviousInfluencer.data.id;
                                $scope.domain = responsePreviousInfluencer.data.domain;
                                $scope.name = responsePreviousInfluencer.data.name;
                                $scope.phone = responsePreviousInfluencer.data.phone;
                                $scope.email = responsePreviousInfluencer.data.email;
                                $scope.description = responsePreviousInfluencer.data.description;
                                $scope.pendingCompleted = responsePreviousInfluencer.data.pending_completed == 1 ? true : false;
                                if (responsePreviousInfluencer.data.systemEmail != null) {
                                    $scope.system_email = responsePreviousInfluencer.data.systemEmail;
                                } else {
                                    $scope.system_email = responsePreviousInfluencer.data.id + "@getachoo.com";
                                }

                                $scope.status_icon = adminService.getActiveIcon($scope.InfluencerDetail.isActive);
                                $scope.approval_icon = adminService.getApproveIcon($scope.InfluencerDetail.status);

                                var previoudInfActiveUrl = $rootScope.apiUrl + 'admin/getInfluencerActive';
                                $http.get(previoudInfActiveUrl, {
                                        loader: false
                                    })
                                    .success(function (responsePreviousInfActive) {
                                        $scope.status = responsePreviousInfActive.data;
                                        $scope.status.forEach(function (val) {
                                            if (val.id == $scope.InfluencerDetail.isActive) {
                                                val.ticked = true;
                                                $scope.outputStatus = val;
                                            }
                                        })
                                    })

                                var previousInfStatusUrl = $rootScope.apiUrl + 'admin/getInfluencerStatus';
                                $http.get(previousInfStatusUrl, {
                                        loader: false
                                    })
                                    .success(function (responsePreviousInfStatus) {
                                        $scope.approval = responsePreviousInfStatus.data;
                                        $scope.approval.forEach(function (val) {
                                            if (val.id == $scope.InfluencerDetail.status) {
                                                val.ticked = true;
                                                $scope.outputApproval = val;
                                            }
                                        })
                                    })

                                var previousInfGenderUrl = $rootScope.apiUrl + 'admin/getInfluencerGender';
                                $http.get(previousInfGenderUrl, {
                                        loader: false
                                    })
                                    .success(function (responsePreviousInfGender) {
                                        $scope.gender = responsePreviousInfGender.data;
                                        $scope.gender.forEach(function (val) {
                                            val.checked = false;
                                            if (val.id == $scope.InfluencerDetail.gender) {
                                                $scope.selectedGender = val.id;
                                                val.checked = true;
                                            }
                                        })
                                    })

                                $scope.networks = [];
                                var object = {
                                    id: null,
                                    name: "No Network",
                                    description: null,
                                    contact_email: null,
                                    country: {
                                        id: null,
                                        code: null,
                                        name: null,
                                        isActive: null
                                    },
                                    net_id: null,
                                    address: null,
                                    phone: null,
                                    ticked: false
                                }
                                $scope.networks.push(object);
                                var previousInfNetworksUrl = $rootScope.apiUrl + 'networks';
                                $http.get(previousInfNetworksUrl, {
                                        loader: false
                                    })
                                    .success(function (responsePreviousInfNetworks) {
                                        angular.forEach(previousInfNetworksUrl.data, function (val) {
                                            if (val.deletedFlag == 0) {
                                                $scope.networks.push(val);
                                                if ($scope.InfluencerDetail.network != null) {
                                                    if (val.id == $scope.InfluencerDetail.network.id) {
                                                        val.ticked = true;
                                                    }
                                                }
                                            }
                                        })
                                    })

                                $scope.countries.forEach(function (val) {
                                    if ($scope.InfluencerDetail.country != null) {
                                        if (val.id == $scope.InfluencerDetail.country.id) {
                                            val.ticked = true;
                                            $scope.outputCountry = val;
                                        }
                                    }
                                })

                                $scope.outputLanguage = [];
                                $scope.languages.forEach(function (val) {
                                    $scope.InfluencerDetail.influencerLanguages.forEach(function (item) {
                                        if (item.language != null) {
                                            val.ticked = false;
                                            if (val.id == item.language.id) {
                                                val.ticked = true;
                                                $scope.outputLanguage.push(val);
                                            }
                                        }
                                    })
                                })

                                $scope.channels = [];
                                $scope.addNewChannels = [];
                                $scope.editChannels = [];
                                $scope.tempEditChannels = [];
                                $scope.removeChannels = [];
                                var previousInfChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.influencerId;
                                $http.get(previousInfChannelUrl, {
                                        loader: false
                                    })
                                    .success(function (responsePreviousInfChannel) {
                                        angular.forEach(responsePreviousInfChannel.data, function (item) {
                                            $scope.channels.push(item);
                                        })
                                    });

                                $scope.PlatformIcon = function (platform_id) {
                                    return adminService.getPlatformIcon(platform_id);
                                }
                            }
                        })
                        .error(function (responsePreviousInfluencer) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        });

                }, function (responseUpdateNPreviousInf) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseUpdateNPreviousInf.message;
                })
        }

        $scope.saveNNext = function (id, save) {
            if (save == false) {
                $scope.numberClick = $scope.numberClick + 1;
            }

            //from current index, get next index
            $scope.influencerIndex = $scope.influencerIndex + 1;
            var nextInfluencerIndex = 0;
            if ($scope.influencerIndex < 25 && $scope.currentPage <= $scope.pages) {
                nextInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.influencerIndex;
                if (nextInfluencerIndex >= $scope.number) {
                    $scope.influencerIndex -= 1;
                    nextInfluencerIndex = $scope.number;
                }
            } else if ($scope.influencerIndex == 25 && $scope.currentPage < $scope.pages) {
                $scope.currentPage += 1;
                $scope.influencerIndex = 0;
                nextInfluencerIndex = (($scope.currentPage - 1) * 25) + $scope.influencerIndex;
            } else if ($scope.influencerIndex == 25 && $scope.currentPage == $scope.pages) {
                $scope.influencerIndex = 24;
                nextInfluencerIndex = $scope.number;
            }

            nextInfluencerIndex = nextInfluencerIndex - $scope.numberClick;

            $scope.selectedDetailsCountryId = "";
            $scope.countries.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedDetailsCountryId = val.id;
                }
            });

            $scope.selectedDetailsNetworkId = "";
            $scope.networks.forEach(function (val) {
                if (val.ticked === true) {
                    $scope.selectedDetailsNetworkId = val.id;
                }
            });

            $scope.selectedDetailsLanguageId = [];
            $scope.languages.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsLanguageId.push(val.id)
            });

            $scope.selectedDetailsStatus = "";
            $scope.status.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsStatus = val.id;
            });

            $scope.selectedDetailsApproval = "";
            $scope.approval.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedDetailsApproval = val.id;
            });

            $scope.selectedGender = "";
            $scope.gender.forEach(function (val) {
                if (val.checked === true)
                    $scope.selectedGender = val.id;
            });

            $scope.selectedReason = "";
            $scope.dismissReasons.forEach(function (val) {
                if (val.ticked === true)
                    $scope.selectedReason = val.id;
            });

            var infDetailData = {
                domain: $scope.domain,
                name: $scope.name,
                description: $scope.description,
                isActive: $scope.selectedDetailsStatus,
                network: $scope.selectedDetailsNetworkId,
                country: $scope.selectedDetailsCountryId,
                phone: $scope.phone,
                email: $scope.email,
                // status: $scope.selectedDetailsApproval,
                status: 2,
                languages: $scope.selectedDetailsLanguageId,
                system_email: $scope.system_email,
                pending_completed: save == true ? $scope.pendingCompleted : true,
                gender: $scope.selectedGender,
                dismiss_reason: $scope.selectedReason,
                isPending: save == false ? true : false

            }

            var req = {
                url: $rootScope.apiUrl + 'admin/updateNNext/' + id,
                method: 'POST',
                data: JSON.stringify(infDetailData)
            }

            adminService.updateNNext(id, infDetailData, true)
                .then(function (responseInfDetails) {
                    //handle channels: remove-edit-add
                    $scope.handleChannels(id, responseInfDetails.influencer_management_log_id);

                    var nextData = {
                        searchString: $scope.searchString,
                        selectedPlatform: $scope.selectedPlatform,
                        selectedCountryId: $scope.selectedCountryId,
                        selectedNetworkId: $scope.selectedNetworkId,
                        selectedLanguageId: $scope.selectedLanguageId,
                        selectedStatus: $scope.selectedStatus,
                        selectedApproval: $scope.selectedApproval,
                        fromPeriodDays: $scope.selectedPeriod,
                        pageNo: $scope.currentPage,
                        sortByColumn: $scope.fieldName,
                        sortType: $scope.order,
                        selectedGender: $scope.selectedGender,
                        complete: save
                    };

                    var req = {
                        url: $rootScope.apiUrl + 'admin/getNextInfluencerMultiHashTags/' + nextInfluencerIndex,
                        method: 'POST',
                        data: JSON.stringify(nextData)
                    }
                    $http(req).success(function (responseNextInf) {
                            if (responseNextInf.data == null) {
                                // var errorModalInstance = $modal.open({
                                //     scope: $scope,
                                //     templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                //     windowClass: 'modal-dialog-mention-error'
                                // });
                                // $scope.errorModalInstance = errorModalInstance;
                                // $scope.errorMessage = responseNextInf.data;
                                $scope.influencerDetailsModalInstance.close();
                            } else {
                                $scope.InfluencerDetail = responseNextInf.data;
                                $scope.influencerId = responseNextInf.data.id;
                                $scope.domain = responseNextInf.data.domain;
                                $scope.name = responseNextInf.data.name;
                                $scope.phone = responseNextInf.data.phone;
                                $scope.email = responseNextInf.data.email;
                                $scope.description = responseNextInf.data.description;
                                $scope.pendingCompleted = responseNextInf.data.pending_completed == 1 ? true : false;
                                if (responseNextInf.data.systemEmail != null) {
                                    $scope.system_email = responseNextInf.data.systemEmail;
                                } else {
                                    $scope.system_email = responseNextInf.data.id + "@getachoo.com";
                                }

                                $scope.status_icon = adminService.getActiveIcon($scope.InfluencerDetail.isActive);
                                $scope.approval_icon = adminService.getApproveIcon($scope.InfluencerDetail.status);

                                var nextInfActiveUrl = $rootScope.apiUrl + 'admin/getInfluencerActive';
                                $http.get(nextInfActiveUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfActive) {
                                        $scope.status = responseNextInfActive.data;
                                        $scope.status.forEach(function (val) {
                                            if (val.id == $scope.InfluencerDetail.isActive) {
                                                val.ticked = true;
                                                $scope.outputStatus = val;
                                            }
                                        })
                                    })

                                var NextInfStatusUrl = $rootScope.apiUrl + 'admin/getInfluencerStatus';
                                $http.get(NextInfStatusUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfStatus) {
                                        $scope.approval = responseNextInfStatus.data;
                                        $scope.approval.forEach(function (val) {
                                            if (val.id == $scope.InfluencerDetail.status) {
                                                val.ticked = true;
                                                $scope.outputApproval = val;
                                            }
                                        })
                                    })

                                var NextInfGenderUrl = $rootScope.apiUrl + 'admin/getInfluencerGender';
                                $http.get(NextInfGenderUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfGender) {
                                        $scope.gender = responseNextInfGender.data;
                                        $scope.gender.forEach(function (val) {
                                            val.checked = false;
                                            if (val.id == $scope.InfluencerDetail.gender) {
                                                $scope.selectedGender = val.id;
                                                val.checked = true;
                                            }
                                        })
                                    })

                                var NextInfDismissReasonUrl = $rootScope.apiUrl + 'admin/getDismissReason';
                                $http.get(NextInfDismissReasonUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfDismissReason) {
                                        $scope.dismissReasons = responseNextInfDismissReason.data;
                                        angular.forEach($scope.dismissReasons, function (reason) {
                                            reason.ticked = false;
                                            if (reason.id == $scope.InfluencerDetail.dismiss_reason) {
                                                reason.ticked = true;
                                            }
                                        })
                                    })

                                $scope.networks = [];
                                var object = {
                                    id: null,
                                    name: "No Network",
                                    description: null,
                                    contact_email: null,
                                    country: {
                                        id: null,
                                        code: null,
                                        name: null,
                                        isActive: null
                                    },
                                    net_id: null,
                                    address: null,
                                    phone: null,
                                    ticked: false
                                }
                                $scope.networks.push(object);
                                var NextInfNetworksUrl = $rootScope.apiUrl + 'networks';
                                $http.get(NextInfNetworksUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfNetworks) {
                                        angular.forEach(responseNextInfNetworks.data, function (val) {
                                            if (val.deletedFlag == 0) {
                                                $scope.networks.push(val);
                                                if ($scope.InfluencerDetail.network != null) {
                                                    if (val.id == $scope.InfluencerDetail.network.id) {
                                                        val.ticked = true;
                                                    }
                                                }
                                            }
                                        })
                                    })

                                $scope.countries.forEach(function (val) {
                                    val.ticked = false;
                                    if ($scope.InfluencerDetail.country != null) {
                                        if (val.id == $scope.InfluencerDetail.country.id) {
                                            val.ticked = true;
                                            $scope.outputCountry = val;
                                        }
                                    }
                                })

                                $scope.outputLanguage = [];
                                $scope.languages.forEach(function (val) {
                                    $scope.InfluencerDetail.influencerLanguages.forEach(function (item) {
                                        if (item.language != null) {
                                            val.ticked = false;
                                            if (val.id == item.language.id) {
                                                val.ticked = true;
                                                $scope.outputLanguage.push(val);
                                            }
                                        }
                                    })
                                })

                                $scope.channels = [];
                                $scope.addNewChannels = [];
                                $scope.editChannels = [];
                                $scope.tempEditChannels = [];
                                $scope.removeChannels = [];
                                var nextInfChannelUrl = $rootScope.apiUrl + 'admin/getInfluencerChannel/' + $scope.influencerId;
                                $http.get(nextInfChannelUrl, {
                                        loader: false
                                    })
                                    .success(function (responseNextInfChannel) {
                                        angular.forEach(responseNextInfChannel.data, function (item) {
                                            $scope.channels.push(item);
                                        })
                                    });


                                $scope.PlatformIcon = function (platform_id) {
                                    return adminService.getPlatformIcon(platform_id);
                                }
                            }
                        })
                        .error(function (responseNextInf) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = responseNextInf.message;
                        });
                }, function (responseInfDetails) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseInfDetails.message;
                })
        }

        $scope.delete = function (id) {

            var deleteConfirmModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers_influencer_delete.html?app_v=deployDate',
                controller: 'DeleteInfluencerCtrl',
                id: id
            });

            $scope.deleteConfirmModalInstance = deleteConfirmModalInstance;
        }

        $scope.newChannelModalHandler = function () {
            var channelModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
                controller: 'NewChannelCtrl'
            });

            $scope.channelModalInstance = channelModalInstance;
            $scope.index = null;
            channelModalInstance.result.then(function (result) {
                var isValidToAdd = true;
                if ($scope.channels) {
                    if (result) {
                        $scope.checkDuplicateChannel(result.newChannel, $scope.channels);
                        if ($scope.isValidToAdd) {
                            $scope.channels.push(result.newChannel);
                        }
                        $scope.isValidToAdd = true;
                        $scope.checkDuplicateChannel(result.newChannel, $scope.addNewChannels);
                        if ($scope.isValidToAdd) {
                            $scope.addNewChannels.push(result.newChannel);
                        }
                        $scope.isValidToAdd = true;
                    }
                }
            }, function () {
                //
            });
        }

        $scope.editChannelModalHandler = function (index) {
            var channelModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_new_influencers/addNewChannelModal.html?app_v=deployDate',
                controller: 'NewChannelCtrl'
            })

            $scope.channelModalInstance = channelModalInstance;
            $scope.index = index;

            var indexNo = $scope.channels.indexOf(index);

            channelModalInstance.result.then(function (result) {
                if (result) {
                    $scope.checkDuplicateChannel(result.newChannel, $scope.channels);
                    if ($scope.isValidToAdd) {
                        if (~indexNo) {
                            $scope.channels.splice(indexNo, 1, result.newChannel);
                        }
                    }
                    $scope.isValidToAdd = true;

                    $scope.checkDuplicateChannel(result.newChannel, $scope.tempEditChannels);
                    if ($scope.isValidToAdd) {
                        if (result.newChannel.id) {
                            $scope.editChannels.push(result.newChannel);
                            $scope.channels.splice(indexNo, 1, result.newChannel);
                        }
                        else { // when edit an item that new item (not saved)
                            var n;
                            for (var i=0; i<$scope.addNewChannels.length; i++) {
                                if ($scope.addNewChannels[i].handle === result.newChannel.handle &&
                                    $scope.addNewChannels[i].platform_id === result.newChannel.platform_id) {
                                    n = i;
                                    break;
                                }
                            }
                            $scope.addNewChannels.splice(n, 1, result.newChannel);
                        }
                    }
                    $scope.isValidToAdd = true;
                    $scope.index = null;
                }
            })

        }

        $scope.removeChannel = function (index) {
            var indexNo = $scope.channels.indexOf(index);
            if (~index) {
                $scope.channels.splice(indexNo, 1);
            }
            if (index.id != null) {
                $scope.removeChannels.push(index);
            }
        }

        $scope.mergeModalHandler = function () {
            var mergeModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/influencers_influencer_merge.html?app_v=deployDate',
                controller: 'MergeInfluencerController'
            })

            $scope.mergeModalInstance = mergeModalInstance;
            $scope.index = $scope.InfluencerDetail;

            mergeModalInstance.result.then(function (result) {
                $scope.closeModal();
            }, function () {
                //
            });

        }

        $scope.closeModal = function () {
            $modalInstance.dismiss();
        }

        var getOfficialLanguage = function (countryId) {
            return advertiserProjectDetailService.getLanguageByCountry({countries: [countryId]}, false)
                .then(function(response) {
                    return response.data;
                }, function(response) {

                })
        };

        var buildGroupingLanguageDropdown = function (defaultLang, countryId) {
            getOfficialLanguage(countryId)
                .then( function(officialLang) {
                    var officialLangList = officialLang.language;
                    var languagesList = angular.copy(definitions.languages);
                    var gOfficialStartNode = {
                            name: '<strong style="border-bottom: 1.5px #18bafa solid;">Official</strong>',
                            msGroup: true
                        },
                        gOtherStartNode = {
                            name: '<strong style="border-bottom: 1.5px #18bafa solid;">Others</strong>',
                            msGroup: true
                        },
                        gEndNode = {
                            msGroup: false
                        };

                    var officialArr = [gOfficialStartNode];
                    for (var i=0; i<languagesList.length; i++) {
                        if (defaultLang.id === languagesList[i].id) {
                            languagesList[i].ticked = true;
                        }

                        for (var j=0; j<officialLangList.length; j++) {
                            if (officialLangList[j].id === languagesList[i].id) {
                                languagesList.splice(i, 1);
                                break;
                            }
                        }
                    }

                    for (var k=0; k<officialLangList.length; k++) {
                        if (defaultLang.id === officialLangList[k].id) {
                            officialLangList[k].ticked = true;
                        }
                        officialArr.push(officialLangList[k])
                    }

                    languagesList.unshift(gOtherStartNode);
                    languagesList.push(gEndNode);
                    officialArr.push(gEndNode);

                    var newList = officialArr.concat(languagesList);
                    $scope.languages = newList;
                });
        };

        function changeLanguage(countryId) {
            var getCountryLanguageUrl = $rootScope.apiUrl + 'admin/getCountryLanguage?country_id=' + countryId;
            $http.get(getCountryLanguageUrl, {
                loader: false
            }).success(function (responseCountryLanguage) {
                /*$scope.languages.forEach(function (defaultLang) {
                    defaultLang.ticked = false;
                    if (defaultLang.id == responseCountryLanguage.data.id) {
                        defaultLang.ticked = true;
                    }

                })*/

                buildGroupingLanguageDropdown(responseCountryLanguage.data, countryId);
            })
        }

        // $scope.$watch('selectedCountry', function(newValue, oldValue){
        //     $scope.new_language_id = "";

        //     if(newValue !== oldValue && newValue !== undefined && $scope.enableWatch){
        //         $scope.new_language_id = newValue[0].id;

        //         var getCountryLanguageUrl = $rootScope.apiUrl + 'admin/getCountryLanguage?country_id=' + $scope.new_language_id;
        //         $http.get(getCountryLanguageUrl, {loader: false})
        //             .success(function(responseCountryLanguage){
        //                 $scope.languages.forEach(function (defaultLang) {
        //                     defaultLang.ticked = false;
        //                     if (defaultLang.id == responseCountryLanguage.data.id) {
        //                         defaultLang.ticked = true;
        //                     }
        //                 })
        //             })
        //     }
        // });

        $scope.manualCrawlerChecking = function (influencer_id) {
            var manualCrawlerCheckingModalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/admin/influencerManagement/influencer_management_influencers/manualCrawlerChecking.html?app_v=deployDate',
                controller: 'manualCrawlerCheckingCtrl'
            })

            $scope.influencer_id = influencer_id;
        }

    })

    .controller('DeleteInfluencerCtrl', function ($scope, $modal, $location, $http, $rootScope, localStorageService, $modalInstance) {
        $scope.confirmDelete = function () {
            var req = {
                url: $rootScope.apiUrl + 'admin/deleteInfluencer/' + $scope.id,
                method: 'DELETE'
            }

            $http(req).success(function (responseDeleteInfluencer) {
                    $scope.modalInstance.close(function () {
                        $log.info('Close Modal now');
                    })

                    location.reload(true);
                })
                .error(function (responseDeleteInfluencer) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = responseDeleteInfluencer.message;
                });
        }

        $scope.closeModal = function () {
            $modalInstance.close();
        }

    })

    .controller('manualCrawlerCheckingCtrl', function ($scope, $modal, $http, $rootScope) {
        var url_manualCrawlerChecking = $rootScope.apiUrl + 'admin/manualCrawlerChecking?blog_id=' + $scope.influencer_id;
        $http.get(url_manualCrawlerChecking, {
                loader: true
            })
            .success(function (response) {
                $scope.manualCrawlerCheckingResult = response.data;
            }, function (response) {
                var errorModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                    windowClass: 'modal-dialog-mention-error'
                });
                $scope.errorModalInstance = errorModalInstance;
                $scope.errorMessage = response.message;
            })
    })
